import { loadJsonFromUrl } from "../util/json-loader";
import { carouselFallbackContent } from "./carousel-fallback-content";
import { CarouselItem, RawCarouselItem } from "./carousel-types";

const CAROUSEL_JSON_URL =
  "https://assets.richmondwoodturners.org/carousel/carousel.json";

export async function getCarouselItems(): Promise<CarouselItem[]> {
  const items = await loadJsonFromUrl<RawCarouselItem[]>(CAROUSEL_JSON_URL);
  if (items === null) {
    console.error(
      `Failed to load carousel items from ${CAROUSEL_JSON_URL}. Using fallback content.`,
    );
  }

  const now = new Date();

  return (items ?? carouselFallbackContent)
    .map((item) => parseCarouselItem(item))
    .filter((item) => !item.startDate || item.startDate <= now)
    .filter((item) => !item.endDate || item.endDate >= now)
    .sort((a, b) => a.priority - b.priority);
}

function endOfDay(date: Date): Date {
  const result = new Date(date);
  result.setUTCHours(23, 59, 59, 999);
  return result;
}

function parseCarouselItem(item: RawCarouselItem): CarouselItem {
  return {
    type: item.type,
    startDate: item.start_date ? new Date(item.start_date) : null,
    endDate: item.end_date ? endOfDay(new Date(item.end_date)) : null,
    priority: item.priority,
    duration: item.duration ?? null,
    background: item.background ?? null,
    video: item.video,
    event: item.event,
    post: item.post,
    featured_turning: item.featured_turning,
  };
}
